module.exports = __webpack_public_path__ + "img/[衰].02865424.svg";